import { render, staticRenderFns } from "./ModalCadastro.vue?vue&type=template&id=29f48a7c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ModalCadastro.vue?vue&type=script&defer=true&lang=js"
export * from "./ModalCadastro.vue?vue&type=script&defer=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f48a7c",
  null
  
)

export default component.exports